import { useMobile } from 'src/hooks/useMobile'
import { Link } from 'gatsby'
import DktSlider from 'src/components/restructure/common/DktSlider/DktSlider'
import { useStripe } from 'src/graphql/queries/stripe'
import { dispatchAmplitudeEvent } from 'src/utils/amplitude'
import { getStandardObject } from 'src/utils/amplitude/getStandardObject'
import { useGlobalContext } from 'src/components/contexts/GlobalContext'

import StripeText from './StripeText'

function ConditionalLink({
  link,
  onClick,
  children,
}: {
  link?: string
  onClick?: () => void
  children: React.ReactNode
}) {
  const isTargetBlank = link?.charAt(0) !== '/' && !link?.includes('decathlon')

  return link ? (
    <Link
      rel="noreferrer"
      target={isTargetBlank ? '_blank' : '_self'}
      to={link}
      onClick={onClick}
    >
      {children}
    </Link>
  ) : (
    <div>{children}</div>
  )
}

export const Stripe = () => {
  const { isMobile } = useMobile()

  const stripeData = useStripe()
  const stripeSections = stripeData?.cmsGlobal?.sections?.find(
    (section) => section.name === 'Stripe - Header [Global]'
  )

  const { pageData } = useGlobalContext()
  const headerStripeData = stripeSections?.data
  const isSessionEnabled = headerStripeData?.enableSession
  const standardObj = getStandardObject(pageData)

  function sendEventClick(marqueeName: string) {
    dispatchAmplitudeEvent({
      eventName: 'Click Marquee',
      eventData: {
        ...standardObj,
        'click name': marqueeName,
      },
    })
  }

  if (isSessionEnabled === false) {
    return <></>
  }

  return (
    <div
      data-testid="section-stripe"
      className="flex justify-center bg-yellow-300 h-8 md:h-10 text-center"
    >
      {headerStripeData?.stripes?.length ? (
        <DktSlider
          showControls={false}
          direction="vertical"
          autoplayInterval={5500}
          sensitivity={10}
          sliderId="stripe-slider"
        >
          {headerStripeData?.stripes.map((stripe) => (
            <div
              key={`${stripe.stripeText}-${stripe.link}`}
              className="flex items-center justify-center w-full"
            >
              <ConditionalLink
                link={stripe.link}
                onClick={() => sendEventClick(stripe.stripeText)}
              >
                <div
                  className="flex items-center mobile-caption-regular desktop-body-regular-text3 text-center py-[8px] px-[16px] leading-none"
                  data-testid="stripe-item"
                >
                  {stripe.stripeText && <StripeText text={stripe.stripeText} />}
                  {stripe.icon && (
                    <img
                      alt="Icon"
                      className="ml-[3px]"
                      src={stripe.icon}
                      width={isMobile ? '16' : '24'}
                      height={isMobile ? '16' : '24'}
                    />
                  )}
                </div>
              </ConditionalLink>
            </div>
          ))}
        </DktSlider>
      ) : (
        <div
          data-testid="section-stripe"
          className="flex items-center h-[32px]"
        >
          <span
            data-testid="stripe-item"
            className="mobile-caption-regular desktop-body-regular-text3"
          >
            <ConditionalLink
              link={headerStripeData?.stripes[0]?.link}
              onClick={() => {
                if (headerStripeData?.stripes[0]?.stripeText) {
                  sendEventClick(headerStripeData.stripes[0].stripeText)
                }
              }}
            >
              (
              <div className="flex items-center">
                {headerStripeData?.stripes[0]?.stripeText}
                {headerStripeData?.stripes[0]?.icon && (
                  <img
                    alt="Icon"
                    className="ml-[3px]"
                    src={headerStripeData?.stripes[0]?.icon}
                    width={isMobile ? '16' : '24'}
                    height={isMobile ? '16' : '24'}
                  />
                )}
              </div>
              )
            </ConditionalLink>
          </span>
        </div>
      )}
    </div>
  )
}
